<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from "vuex";
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "MarketingContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	computed: {
		...mapState(["usuario"]),
	},
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("marketing_pdf")) {
				m.push({
					titulo: "Gerador de PDF",
					titulo_app: "Gerador de PDF",
					icon: "mdi-file-pdf-box",
					to: "/marketing",
					tooltip: "Gerador de etiqueta de produtos em promoção",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>